import Backbone from 'backbone'
import user from '../../../user'
import config from '../../../config'
import ResultModel from '../../../models/result'
import Alert from '../../../helpers/alert'

const TimesTableView = Backbone.View.extend({
    tagName: 'div',
    events: {
        'click .f3_numpad_button': 'btn',
    },
    randomNumbers: [1,2,3,4,5,6,7,8,9,10,11,12],
    randomTimesBy: [1,2,3,4,5,6,7,8,9,10,11,12],
    userAnswer: '',
    count: 0,
    initialize(options) {
        this.testModel = options.testModel
        this.titleModel = options.titleModel

        this.randomNumbers = this.randomNumbers.sort(() => 0.5 - Math.random())
        this.randomTimesBy = this.randomTimesBy.sort(() => 0.5 - Math.random())

        // set the start time
        this.testModel.set('start_timestamp', new Date().getTime())
    },
    render() {
        const inOrder = this.model.get('in_order')
        const count = this.testModel.get('count')
        const nextNumber = inOrder ? count + 1 : this.randomNumbers[count]

        this.number = Number(nextNumber)
        this.timesBy = Number(this.model.get('table'))

        this.question = this.number + ' &times ' + this.timesBy
        this.correctAnswer = this.number * this.timesBy + ''

        this.$el.html(`<p class="f3_activity_title">Use the number pad to input your answer.</p>`)

        this.$el.append(`<div class="f3_sum_wrap">
            <div class="f3_sum_item sum_first">` + this.number + `</div>
            <div class="f3_sum_item f3_sum_item_symbol">×</div>
            <div class="f3_sum_item sum_second">` + this.timesBy + `</div>
            <div class="f3_sum_item f3_sum_item_symbol">=</div>
            <div class="f3_sum_item f3_sum_item_answer"></div>
            <br style="clear:both">
        </div>`)

        this.$el.append(`<div class="f3_numpad_wrap">
            <div class="f3_numpad_button" data-id="1">1</div>
            <div class="f3_numpad_button" data-id="2">2</div>
            <div class="f3_numpad_button" data-id="3">3</div>
            <div class="f3_numpad_button" data-id="4">4</div>
            <div class="f3_numpad_button" data-id="5">5</div>
            <div class="f3_numpad_button" data-id="6">6</div>
            <div class="f3_numpad_button" data-id="7">7</div>
            <div class="f3_numpad_button" data-id="8">8</div>
            <div class="f3_numpad_button" data-id="9">9</div>
            <div class="f3_numpad_button" data-id="0">0</div>
            <div class="f3_numpad_button" data-id="C">C</div>
            <div class="f3_numpad_button" data-id="Enter">Enter</div>
        </div>`)

        return this
    },
    btn(evt) {
        const input = evt.target.getAttribute('data-id')

        switch(input) {
            case 'C':
                this.userAnswer = (this.userAnswer + '').substr(0, (this.userAnswer + '').length-1)
                break
            case 'Enter':
                if (this.userAnswer) {
                    this.next()
                    this.userAnswer = ''
                }
                break
            default:
                if (this.userAnswer.length > 2 || this.userAnswer === '0') this.userAnswer = ''
                this.userAnswer += input
                break
        }

        this.$('.f3_sum_item_answer').text(this.userAnswer)
    },
    next() {
        if (this.correctAnswer === this.userAnswer) {
            this.testModel.correct()
        } else {
            this.testModel.incorrect()
        }

        if (this.testModel.get('count') < this.randomTimesBy.length) {
            this.render()
        } else {
            this.testModel.set('end_timestamp', new Date().getTime())

            // this will award the user a star if they got 100% correct
            this.testModel.awardStar()

            // create the results model
            const resultsModel = new ResultModel()
            resultsModel.set({
                user: user.get('uid'),
                app_title: config.get('Name'),
                level: this.titleModel.get('image_prefix'),
                start_timestamp: this.testModel.get('start_timestamp'),
                end_timestamp: this.testModel.get('end_timestamp'),
                score: this.testModel.get('score'),
                total: this.testModel.get('count'),
                fluency_score: this.testModel.get('fluency_score'),
                fluency_total: this.testModel.get('fluency_count'),
                reasoning_score: this.testModel.get('reasoning_score'),
                reasoning_total: this.testModel.get('reasoning_count'),
                problem_score: this.testModel.get('problem_score'),
                problem_total: this.testModel.get('problem_count'),
                star: this.testModel.get('star'),
            })

            // add the results model to the results list
            user.get('results').add(resultsModel)
            user.localSave()

            // save it online
            user.get('results').sync().then(() => {
                // if the result saved move to the results view
                this.model.set({
                    state: 'result',
                })
            })
                .catch((error) => {
                    // if it failed to sync fail move to the results view and show error
                    this.model.set({
                        state: 'result',
                    })

                    if (error) {
                        Alert(error)
                    }
                })
        }
    }
})

export default TimesTableView
